/*import Bootable from '../../mixins/bootable'*/
import Overlayable from '../../mixins/overlayable'
import Toggleable from '../../mixins/toggleable'
import PrefersReducedMotion from '../../utils/prefers-reduced-motion'

export default {
  mixins: [/*Bootable,*/ Overlayable, Toggleable],

  data() {
    return {
      app: null
    }
  },

  props: {
    disabled: Boolean,
    persistent: Boolean,
    fullscreen: Boolean,
    overlapAppHeader: Boolean,
    bottom: Boolean,
    useCloseBtn: {type: Boolean, default: true},
    origin: {
      type: String,
      default: 'center center'
    },
    width: {
      type: [String, Number],
    },
    transition: {
      type: String,
    },
  },

  computed: {
    classes () {
      return {
        'dialog': true,
        'dialog--active': this.isActive,
        'dialog--persistent': this.persistent,
        'dialog--fullscreen': this.fullscreen,
        'dialog--bottom': this.bottom,
        'dialog--overlap-app-header': this.overlapAppHeader,
        'dialog--has-close-btn': this.useCloseBtn,
      }
    },

    computedTransition () {
      return PrefersReducedMotion
        ? 'transition'
        : this.transition === undefined
          ? (this.fullscreen
              ? 'n-dialog-bottom-transition'
              : this.bottom
                ? 'n-dialog-bottom-transition'
                : 'n-dialog-transition')
          : this.transition
    }
  },

  watch: {
    isActive (val) {
      if (val) {
        !this.fullscreen && !this.hideOverlay && this.genOverlay()
        this.fullscreen && this.hideScroll()
        this.$emit('open')
      } else {
        this.$emit('close',true)
        this.removeOverlay()
      }
    }
  },

  mounted () {
    this.app = document.querySelector('[data-app]')
    this.$nextTick(() => {
      this.app && this.app.appendChild(this.$refs.content)
    })
  },

  beforeDestroy () {
    this.removeOverlay();
    
    this.app &&
      this.app.contains(this.$refs.content) &&
      this.app.removeChild(this.$refs.content)
  },

  methods: {
    closeConditional (e) {
      // close dialog if !persistent and clicked outside
      return !this.persistent
    }
  },

  render (h) {
    let classes = Object.keys(this.classes).filter(k => this.classes[k]).join(' ')
    classes += ' ' + this.$vnode.data.staticClass

    const children = []
    const data = {
      'class': classes,
      ref: 'dialog',
      directives: [
        { name: 'click-outside', value: this.closeConditional },
        { name: 'show', value: this.isActive }
      ]
    }

    if (!this.fullscreen) {
      data.style = {
        width: isNaN(this.width) ? this.width : `${this.width}px`
      }
    }

    if (this.$slots.activator) {
      children.push(h('div', {
        'class': 'dialog__activator',
        on: {
          click: e => {
            e.stopPropagation()
            if (!this.disabled) this.isActive = !this.isActive
          }
        }
      }, [this.$slots.activator]))
    }

    let closeBtnWrapper = null

    if(this.useCloseBtn && !this.persistent) {
      let closeBtn = this.$slots.closeBtn || h('n-button', {
        props: {
          icon: true,
          flat: this.fullscreen,
          absolute: true,
          top: true,
          right: true,
          large: true,
        },
      }, [h('n-icon', null, ['close'])])

      closeBtnWrapper = h('span', {
        class: {
          'dialog__close-btn-wrapper': true,
        },
        on: {
          click: e => this.isActive = false
        },
      }, [this.$slots.closeBtn || closeBtn])
    }

    const dialog = h(this.computedTransition, {
      props: { origin: this.origin }
    }, [h('div', data, [this.$slots.default, closeBtnWrapper])])

    children.push(h('div', {
      'class': `dialog__content ${this.bottom ? 'dialog__content--bottom' : ''}`,
      ref: 'content'
    }, [dialog]))

    return h('div', {
      'class': 'dialog__container'
    }, children)
  }
}
